/**
 * Functions of the search engine and the results pager.
 */
function search_top(){

    if(!!document.querySelector('.box--input_search')){

        var search = getParameterByName('search');

        getData(search);

        const filters = document.querySelector("#filters");
        if(filters){
            filters.addEventListener('click', e => {
                e.preventDefault();
            
                const keyword = document.querySelector("input[name=keyword]").value;

                getData(keyword);
            });
        }
    }

    /**
     * Capture the value of a url variable.
     * 
     * @param String name
     * @return String
     */
    function getParameterByName(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    /**
     * Query the data and display it with a pager.
     * 
     * @param String text
     * @return void
     */
    function getData(search) {

        fetch("src/data.json")
        .then(response => {
            return response.json();
        })
        .then(jsondata => {
            let data = [];
            if(search != ''){
                data = filterData(search, jsondata);
            }else{
                data = jsondata;
            }

            printData(data);

            paginator(search);
        });
    }

    /**
     * Filter the records with the text string sent.
     * 
     * @param String text
     * @param Array data
     * @return Array
     */
    function filterData(text, data) {

        let filtered_data = [];

        data.forEach(element => {
            if(element.title.toLowerCase().indexOf(text.toLowerCase()) != -1){
                filtered_data.push(element);
            }
        });

        return filtered_data;
    }

    /**
     * Print the records resulting from the query.
     * 
     * @param Array data
     * @return void
     */
    function printData(data) {
        
        let body = document.querySelector('.box-content__list-results');
        let html = '';

        data.forEach(element => {
            html += `<div class="box-content__list-item-results">
                        <h2 class="list-results__title">${element.title}</h2>
                        <p class="list-results__description ">${element.description}</p>
                        <div class="box_button_read--more read-more__fix read_more--mobile-left"><a href="${element.link}"><span class="read_more--red">Read more</span> <svg class="red-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5"></path></svg></a></div>
                    </div>`;
        });

        body.innerHTML = '';

        if(html == ''){
            /* body.innerHTML = `<div class="box-content__list-item-results">
                                <p class="list-results__description ">No hay resultados para esta busqueda...</p>
                            </div>`; */
        }else{
            body.innerHTML = html;
        }
    }

    /**
     * Build a pager with the query results.
     * 
     * @param String search
     * @return void
     */
    function paginator(search){

        const wrapper = document.querySelector(".box-content__list-results");
        const pagination = document.querySelector(".pagination");
        const items = Array.from(document.querySelectorAll(".box-content__list-item-results"));
        let filteredItems = items;
        let currPage = 1;

        document.addEventListener('click', function (e) {
            const $this = e.target;
            if ($this.classList.contains("page")) {
                currPage = parseInt($this.getAttribute("page"))
                setHTML(wrapper, pagination, search, filteredItems, currPage);
            }
            if ($this.classList.contains("next")) {
                currPage += 1;
                setHTML(wrapper, pagination, search, filteredItems, currPage);
            }
            if ($this.classList.contains("prev")) {
                currPage -= 1;
                setHTML(wrapper, pagination, search, filteredItems, currPage);
            }
        });

        setHTML(wrapper, pagination, search, filteredItems, currPage);
    }

    /**
     * Build the html code for the pager and the list.
     * 
     * @param String wrapper
     * @param String pagination
     * @param String search
     * @param Array items
     * @param Int currPage
     * @return void
     */
    function setHTML(wrapper, pagination, search, items, currPage) {
        wrapper.innerHTML = "";
        pagination.innerHTML = "";
        const { totalItems, currentPage, pageSize, totalPages, startPage, endPage, startIndex, endIndex, pages } = paginate(items.length, currPage, 3, 3);
      
        const nav = document.createElement("nav");
        nav.classList.add(...['nav-paginator']);
      
        let paginationHTML = "";
        paginationHTML += `<button ${currentPage === 1 && 'disabled'} class="${currentPage === 1 ? 'cursor-not-allowed' : 'prev'} btn-default btn-prev">
                      <span class="sr-only">Previous</span>
                      <svg class="arrow prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path class="prev" fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd"></path>
                      </svg>
                  </button>`;
      
        pages.forEach(page => {
          if (currentPage === page) {
            paginationHTML += `<button class="btn-page-current btn-page-default" page="${page}" ${currentPage === page && 'disabled'}>${page}</button>`
          } else {
            paginationHTML += `<button class="page btn-page btn-page-default" page="${page}" ${currentPage === page && 'disabled'}>${page}</button>`
          }
        });
      
        paginationHTML += `<button ${currentPage === endPage && 'disabled'} class="${currentPage === endPage ? 'cursor-not-allowed' : 'next'} btn-default btn-next">
                      <span class="sr-only">Next</span>
                      <svg class="arrow next" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path class="next" fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path>
                      </svg>
                  </button>`;
      
        nav.innerHTML = paginationHTML;
        pagination.append(nav);
      
        const start = (currentPage - 1) * pageSize, end = currentPage * pageSize;
        items.slice(start, end).forEach(el => {
          wrapper.append(el);
        });

        printResults(search, items, totalItems, startIndex, endIndex);
    }

    /**
     * Prints an accounting summary of the results above the list.
     * 
     * @param String search
     * @param Array filteredItems
     * @param Int totalItems
     * @param Int startIndex
     * @param Int endIndex
     * @return void
     */
    function printResults(search, items, totalItems, startIndex, endIndex){
        let resultsContainer = document.querySelector('.box--input-tooltip-results');

        let paragraphs = resultsContainer.querySelectorAll('p');

        if(search != '' && search != 0){
            paragraphs[0].innerHTML = `Your search for <span class="seatch-red-results">${search}</span> has ${items.length} result(s)`;
        }else{
            paragraphs[0].innerHTML = `Your search has ${items.length} result(s)`;
        }
        
        if(items.length == 0){
            paragraphs[1].innerHTML = `Display 0`;
        }else{
            paragraphs[1].innerHTML = `Display ${startIndex+1}-${endIndex+1} of ${totalItems}`;
        }
    }

    /**
     * Controls the actions and calculations associated with the pager.
     * 
     * @param Int totalItems
     * @param Int currentPage
     * @param Int pageSize
     * @param Int maxPages
     * @return mixed
     */
    function paginate(totalItems, currentPage = 1, pageSize = 2, maxPages = 3) {

        let totalPages = Math.ceil(totalItems / pageSize);
        if (currentPage < 1) {
          currentPage = 1;
        } else if (currentPage > totalPages) {
          currentPage = totalPages;
        }
      
        let startPage, endPage;
        if (totalPages <= maxPages) {
          startPage = 1;
          endPage = totalPages;
        } else {
          let maxPagesBeforeCurrentPage = Math.floor(maxPages / 2);
          let maxPagesAfterCurrentPage = Math.ceil(maxPages / 2) - 1;
          if (currentPage <= maxPagesBeforeCurrentPage) {
            startPage = 1;
            endPage = maxPages;
          } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
            startPage = totalPages - maxPages + 1;
            endPage = totalPages;
          } else {
            startPage = currentPage - maxPagesBeforeCurrentPage;
            endPage = currentPage + maxPagesAfterCurrentPage;
          }
        }
      
        let startIndex = (currentPage - 1) * pageSize;
        let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
      
        let pages = Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);
      
        return {
          totalItems: totalItems,
          currentPage: currentPage,
          pageSize: pageSize,
          totalPages: totalPages,
          startPage: startPage,
          endPage: endPage,
          startIndex: startIndex,
          endIndex: endIndex,
          pages: pages
        };
    }
}

search_top();

export default search_top;